import { signal } from '@angular/core';
import { UserCredentialsResponse } from '@core/domain/auth.dto';

export const jwtCredentials = signal<UserCredentialsResponse | null>(null);
export const isRefreshingToken = signal<boolean>(false);
